/* CHAOS Feature Slider — scroll-snap slider.
   Each [data-cf-fs] instance is self-contained; multiple can coexist. */
(function () {
  'use strict';

  var ATTR = 'data-cf-fs';
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function nudgeVideos(root) {
    // Belt-and-suspenders: even with autoplay+muted+playsinline attrs, browsers
    // sometimes refuse the first play (Chrome's auto-throttle when multiple
    // autoplay videos exist on a page, Safari iOS power-save, etc). Explicitly
    // call .play() and swallow the rejection if the browser still refuses.
    root.querySelectorAll('video[autoplay]').forEach(function (v) {
      v.muted = true;
      try {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) { /* ignore */ }
    });
  }

  function init(root) {
    if (root.dataset.cfFsInit === '1') return;
    root.dataset.cfFsInit = '1';

    nudgeVideos(root);

    var track = root.querySelector('[data-cf-fs-track]');
    var slides = root.querySelectorAll('[data-cf-fs-slide]');
    var dots = root.querySelectorAll('[data-cf-fs-dot]');
    var prevBtn = root.querySelector('[data-cf-fs-prev]');
    var nextBtn = root.querySelector('[data-cf-fs-next]');
    var live = root.querySelector('[data-cf-fs-live]');
    if (!track || slides.length === 0) return;

    var autoplay = root.dataset.autoplay === 'true' && !prefersReducedMotion && slides.length > 1;
    var interval = parseInt(root.dataset.interval, 10) || 6500;
    var idx = 0;
    var timer = null;
    var paused = false;

    function go(n) {
      if (slides.length < 2) return;
      if (n < 0) n = slides.length - 1;
      if (n >= slides.length) n = 0;
      idx = n;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      updateDots();
      announce();
    }

    function updateDots() {
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
      }
    }

    function announce() {
      if (live) live.textContent = 'Slide ' + (idx + 1) + ' of ' + slides.length;
    }

    function startAuto() {
      if (!autoplay || paused) return;
      stopAuto();
      timer = window.setInterval(function () { go(idx + 1); }, interval);
    }
    function stopAuto() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); startAuto(); });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); startAuto(); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(idx - 1); startAuto(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); startAuto(); }
    });

    // Track manual scroll / swipe → sync active dot
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var sl = track.scrollLeft;
        var closest = 0;
        var min = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var d = Math.abs(slides[i].offsetLeft - sl);
          if (d < min) { min = d; closest = i; }
        }
        if (closest !== idx) { idx = closest; updateDots(); announce(); }
      }, 80);
    }, { passive: true });

    // Pause on hover / focus
    root.addEventListener('mouseenter', function () { paused = true; stopAuto(); });
    root.addEventListener('mouseleave', function () { paused = false; startAuto(); });
    root.addEventListener('focusin',    function () { paused = true; stopAuto(); });
    root.addEventListener('focusout',   function (e) {
      if (!root.contains(e.relatedTarget)) { paused = false; startAuto(); }
    });

    // Pause when off-screen + retry video autoplay when scrolled into view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startAuto();
            nudgeVideos(root);
          } else {
            stopAuto();
          }
        });
      }, { threshold: 0.25 });
      io.observe(root);
    }

    updateDots();
    announce();
    startAuto();
  }

  function initAll() {
    document.querySelectorAll('[' + ATTR + ']').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify section editor hooks
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();
